import styled from '@emotion/styled';
import Theme from 'App.theme';
import Label from 'components/Label/Label';

export const PartActions = styled.div`
  padding-right: 2rem;
`;

export const TrayHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
`;

export const SubTableWrapperCell = styled.td`
  column-span: all;
  padding: unset;
`;

export const SetManual = styled(Label)`
  display: flex;
  flex-direction: column;
`;

export const DropzoneContainer = styled.div``;

export const SetManualContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SetManualList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid ${Theme.colours.primary};
  border-radius: 20px;
  width: 100%;
  padding: 1rem;
`;

export const SetManualItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SetManualLink = styled.a``;

export const SelectionToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
`;
